import { Stepper } from '@mantine/core';
import { Check } from 'lucide-react';

interface StepperProps {
  active: number;
  onStepClick?: (step: number) => void;
  patientStepValid: boolean;
  deviceStepValid: boolean;
  sessionTypeStepValid: boolean;
}

export function SessionCreationStepper({
  active,
  onStepClick,
  patientStepValid,
  deviceStepValid,
  sessionTypeStepValid,
}: StepperProps) {
  return (
    <Stepper
      active={active}
      onStepClick={onStepClick}
      orientation='vertical'
      size='sm'
    >
      <Stepper.Step
        label='Selezione Utente'
        description="Scegli l'utente per la sessione"
        completedIcon={patientStepValid ? <Check size={14} /> : undefined}
        disabled={true}
      />
      <Stepper.Step
        label='Selezione Visore'
        description='Scegli il dispositivo VR'
        //icon={deviceStepValid ? <Number size={18} /> : undefined}
        completedIcon={deviceStepValid ? <Check size={14} /> : undefined}
        //disabled={!isStepCompleted(0)}
        disabled={true}
      />
      <Stepper.Step
        label='Configura Sessione'
        description='Scegli il tipo di sessione'
        // icon={sessionTypeStepValid ? <Check size={18} /> : undefined}
        completedIcon={sessionTypeStepValid ? <Check size={14} /> : undefined}
        //disabled={!isStepCompleted(1)}
        disabled={true}
      />
    </Stepper>
  );
}
